import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField } from '@material-ui/core';

const AutoCompleteSelect = ({
	options,
	onChange,
	value,
	label,
	error,
	errorLabel,
}) => {
	return (
		<div>
			<Autocomplete
				size='small'
				id='provinces'
				options={options}
				getOptionLabel={option => option}
				onChange={onChange}
				value={value}
				getOptionSelected={(option, value) => value === value}
				// getOptionDisabled={option => option === district}
				renderInput={params => (
					<TextField
						required={true}
						margin='normal'
						{...params}
						label={label}
						variant='outlined'
						error={error.length > 0 && error === errorLabel}
					/>
				)}
			/>
		</div>
	);
};

export default AutoCompleteSelect;
